import React from 'react';

const InfoField = ({ label, testId, children }) => (
  <div>
    <label style={{ fontSize: '0.875rem', color: '#666', display: 'block', marginBottom: '0.25rem' }}>{label}</label>
    <p data-testid={testId}>{children}</p>
  </div>
);

const LeadInfoSections = ({ lead, formatDate }) => {
  if (!lead) return null;

  return (
    <>
      {/* Waitlist Badge */}
      {lead.status === 'waitlist' && (
        <div className="admin-card" style={{ background: '#FFF3E0', border: '2px solid #F57C00' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div style={{ fontSize: '2rem' }}>⏳</div>
            <div>
              <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#E65100', margin: 0 }}>Wartelisten-Eintrag</h3>
              <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.875rem', color: '#666' }}>
                Dieser Kontakt wartet auf Verfügbarkeit in seiner Region.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Contact Information */}
      <div className="admin-card">
        <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>Kontaktinformationen</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
          <InfoField label="Name" testId="lead-name"><span style={{ fontWeight: '600' }}>{lead.name}</span></InfoField>
          <InfoField label="E-Mail" testId="lead-email"><a href={`mailto:${lead.email}`} style={{ color: '#1B5E20' }}>{lead.email}</a></InfoField>
          <InfoField label="Telefon" testId="lead-phone">{lead.phone ? <a href={`tel:${lead.phone}`} style={{ color: '#1B5E20' }}>{lead.phone}</a> : 'Nicht angegeben'}</InfoField>
          <InfoField label="Adresse" testId="lead-address">{lead.address || 'Nicht angegeben'}</InfoField>
          <InfoField label="PLZ / Land" testId="lead-plz">{lead.plz} ({lead.country || 'Unbekannt'})</InfoField>
          <InfoField label="Erstellt am" testId="lead-created-at">{formatDate(lead.created_at)}</InfoField>
        </div>
      </div>

      {/* Standort */}
      {lead.status !== 'waitlist' && (
        <div className="admin-card">
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>Standort</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <InfoField label="PLZ / Land" testId="lead-plz-detail">{lead.plz} ({lead.country || '-'})</InfoField>
            <InfoField label="Adresse" testId="lead-address-detail">{lead.address || 'Nicht angegeben'}</InfoField>
            <InfoField label="Meereshöhe" testId="lead-altitude">{lead.altitude_m != null ? `${lead.altitude_m} m` : '-'}</InfoField>
          </div>
        </div>
      )}

      {/* Projektdetails */}
      {lead.status !== 'waitlist' && lead.project_type && (
        <div className="admin-card">
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>Projektdetails</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <InfoField label="Projekttyp" testId="lead-project-type">{lead.project_type === 'neubau' ? 'Neubau' : 'Tausch/Sanierung'}</InfoField>
            <InfoField label="Gebäudetyp" testId="lead-building-type">
              {lead.building_type === 'efh' && 'Einfamilienhaus'}
              {lead.building_type === 'mfh' && 'Mehrfamilienhaus'}
              {lead.building_type === 'sonstiges' && `Sonstiges: ${lead.building_type_other || ''}`}
              {!['efh', 'mfh', 'sonstiges'].includes(lead.building_type) && (lead.building_type || '-')}
            </InfoField>
            <InfoField label="Wohnfläche" testId="lead-area">{lead.area_m2 ? `${lead.area_m2} m²` : '-'}</InfoField>
            <InfoField label="Anzahl Personen" testId="lead-persons">{lead.persons != null ? lead.persons : '-'}</InfoField>
            <InfoField label="Warmwasser" testId="lead-hot-water">{lead.heating_hot_water === true ? 'Ja' : lead.heating_hot_water === false ? 'Nein' : '-'}</InfoField>
            <InfoField label="Free Cooling" testId="lead-free-cooling">{lead.free_cooling ? 'Ja' : 'Nein'}</InfoField>
          </div>
        </div>
      )}

      {/* Verbrauchsdaten bei Heizungstausch */}
      {lead.status !== 'waitlist' && lead.prev_system && (
        <div className="admin-card">
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>Verbrauchsdaten bei Heizungstausch</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <InfoField label="Bisheriges System" testId="lead-prev-system">{lead.prev_system}</InfoField>
            <InfoField label="Bisheriger Verbrauch" testId="lead-prev-consumption">{lead.prev_consumption_kwh ? `${lead.prev_consumption_kwh}` : '-'}</InfoField>
            <InfoField label="Energieverbrauch" testId="lead-energy">{lead.energy_consumption_kwh ? `${lead.energy_consumption_kwh} kWh/Jahr` : '-'}</InfoField>
          </div>
        </div>
      )}

      {/* Zeitplan & Details */}
      {lead.status !== 'waitlist' && (
        <div className="admin-card">
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>Zeitplan & Details</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <InfoField label="Zeitrahmen" testId="lead-timeframe">{lead.timeframe || '-'}</InfoField>
            <InfoField label="Förderung Erdwärme" testId="lead-subsidy-erd">{lead.subsidy_amount_erdwaerme ? `${lead.subsidy_amount_erdwaerme} ${lead.currency || 'CHF'}` : 'Nein'}</InfoField>
            <InfoField label="Förderung Luftwärme" testId="lead-subsidy-luft">{lead.subsidy_amount_luftwaerme ? `${lead.subsidy_amount_luftwaerme} ${lead.currency || 'CHF'}` : 'Nein'}</InfoField>
            <InfoField label="Installateur" testId="lead-installer">{lead.has_installer ? `Ja${lead.installer_info ? ': ' + lead.installer_info : ''}` : 'Nein'}</InfoField>
            {lead.additional_info && (
              <div style={{ gridColumn: '1 / -1' }}>
                <InfoField label="Zusätzliche Informationen" testId="lead-additional-info">{lead.additional_info}</InfoField>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default LeadInfoSections;
